import { CATALOGUE_MODE } from "@constants";

import React, { useEffect, useRef } from "react";

const VideoSlide = ({
    item,
    isActive,
}: {
    item: StandbyScreenItemType;
    isActive: boolean;
}): JSX.Element => {
    const videoRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const playVideo = async () => {
            if (isActive) {
                try {
                    // Reset to beginning
                    video.currentTime = 0;
                    await video.play();
                } catch (error) {
                    if (error instanceof Error && error.name !== "AbortError") {
                        console.error("Video play failed:", error);
                    }
                }
            } else {
                // Pause when inactive
                video.pause();
                video.currentTime = 0;
            }
        };

        playVideo();

        return () => {
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        };
    }, [isActive]);

    return (
        <video
            ref={videoRef}
            muted
            playsInline
            loop
            className="h-100 w-100"
            style={{
                objectFit:
                    process.env.REACT_APP_MODE === CATALOGUE_MODE
                        ? "contain"
                        : "fill",
            }}
        >
            <source src={item.content} type="video/mp4" />
        </video>
    );
};

export default VideoSlide;
